import { DoorSeriesInfos } from '../../interfaces/door-series-infos';
import { DoorSeries } from '../door-series';
import { DoorSubType } from '../door-subtype';

export function DoorSteelStiffens(series: DoorSeries, subType: DoorSubType) {
  const steelStiffens = [...(DoorSeriesInfos[series]?.subTypes[subType]?.steelStiffens ?? [])];
  return steelStiffens;
}
